import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-packUp",
  "use": "icon-packUp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-packUp\"><path d=\"M508.829 784.179l333.018-303.385c6.79-6.282 15.906-10.135 25.922-10.135s19.132 3.854 25.946 10.159c6.771 5.632 11.067 14.092 11.067 23.554 0 9.463-4.295 17.922-11.043 23.539l-383.083 348.94-383.033-348.898c-6.797-5.655-11.093-14.114-11.093-23.578s4.296-17.923 11.043-23.539c6.839-6.322 15.954-10.176 25.971-10.176 10.015 0 19.132 3.854 25.946 10.159l329.341 303.362z m1.827-335.452l333.078-303.385c6.785-6.265 15.889-10.107 25.89-10.107s19.105 3.843 25.916 10.132c6.792 5.632 11.103 14.105 11.103 23.586 0 9.481-4.311 17.953-11.078 23.568l-384.91 348.94-383.033-348.898c-6.818-5.654-11.13-14.128-11.13-23.607s4.31-17.953 11.078-23.568c6.84-6.322 15.955-10.177 25.972-10.177 10.015 0 19.133 3.854 25.946 10.159l331.166 303.362z\" p-id=\"4380\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/packUp.svg
// module id = EU1q
// module chunks = 11